module.exports = __webpack_public_path__ + "img/office-2.ce012e73.webp";